export const ACCOUNTS_API = '/atlas/api/v1/accounts'
export const SENTINEL_API = '/sentinel2/api/v1'
export const SENTINEL1_API = '/sentinel/api/v1'
export const SENTNEL2_UI = '/sentinel2-ui/api/v1'
export const COUNTER_PARTY = '/sentinel2-counterparty/api/v1'
export const SCHEDULED_TRANSFERS = '/scheduled-transfers/api/v1/schedules'
export const COUNTRIES_API = '/country-provider/api/v2/countries'
export const MARGIN_SUMMARY_API = '/margin-provider/api/v1/margins'
export const CASH_BALANCES_API = '/cash-balances/api/v2'
export const SESSIONS_ME_API = '/api/v1/sessions/me'
